import { useTheme } from '@mui/material';
import { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';

import Icon from '../../../Icon/Icon';
import { Tooltip } from '../../Tooltip';

export type InfoIconTooltipProps = {
  /**
   * The id of the entry
   */
  id: string;

  /**
   * The message to be displayed in the tooltip
   */
  title: React.ReactNode;

  /**
   * The width of popup
   * @default 300
   */
  width?: number;

  /**
   * The position of the tooltip
   * @default right
   */

  placement?: MuiTooltipProps['placement'];
};

export function InfoIconTooltip(props: InfoIconTooltipProps) {
  const { id, title, width, placement = 'right' } = props;

  const theme = useTheme();

  return (
    <Tooltip id={`${id}-InfoIconTooltip`} width={width} title={title} placement={placement} arrow>
      <Icon id={`${id}-InfoIcon-icon`} icon={'info'} sx={{ ml: theme.spacing(2) }} />
    </Tooltip>
  );
}

export default InfoIconTooltip;
